import { useQuery } from "@tanstack/react-query";

// Tabela IBGE de municípios com coordenadas da sede, gerada por
// web/scripts/gen-municipios.mjs. ~270 KB: carregada por import dinâmico (chunk
// próprio) só por quem precisa — hoje o dashboard Silpi Farma (mapa e diálogo de
// localização manual).

export interface Municipio {
  codigoIbge: string;
  nome: string;
  uf: string;
  lat: number;
  lng: number;
}

export interface BaseMunicipios {
  porCodigo: Map<string, Municipio>;
  porUf: Map<string, Municipio[]>;
}

type Linha = [string, string, string, number, number];

async function carregarMunicipios(): Promise<BaseMunicipios> {
  // O TS infere o JSON como (string | number)[][]; o formato real é garantido pelo gerador.
  const linhas = (await import("./municipios.json")).default as unknown as Linha[];
  const porCodigo = new Map<string, Municipio>();
  const porUf = new Map<string, Municipio[]>();
  for (const [codigoIbge, nome, uf, lat, lng] of linhas) {
    const municipio = { codigoIbge, nome, uf, lat, lng };
    porCodigo.set(codigoIbge, municipio);
    const daUf = porUf.get(uf) ?? [];
    daUf.push(municipio);
    porUf.set(uf, daUf);
  }
  for (const lista of porUf.values()) lista.sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"));
  return { porCodigo, porUf };
}

export function useMunicipios() {
  return useQuery({
    queryKey: ["municipios-ibge"],
    queryFn: carregarMunicipios,
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
